import * as React from "react";
import { computed } from "mobx";
import { observer } from "mobx-react";
import { Collapse } from "antd";

import { DataTableView, ToolbarVisibility, Column } from "src/core/ui/data-table.view";
import { TextView } from "src/core/ui/text.view";

interface Props extends ComponentViewProps<number> {
	ageBands: string[];
	mode: ControlMode;
	occupancyDataSet: DataSet<any>;
	getAllOccupancies?: (maxPax: number) => void;
	newOccupancy?: () => Promise<any>;
}

@observer
export class ContractCustomOccupanciesView extends React.Component<Props, {}> {

	@computed
	private get columns(): Column[] {
		return this.props.ageBands.filter(a=>a!= null).map(name => ({
			key: name.toLowerCase(),
			title: name,
			dataIndex: name.toLowerCase(),
			editable: (text, record: CustomOccupancyPax, index: number, isSelected: boolean) => {
				if (isSelected) {
					return (
						<TextView
							mode={this.props.mode}
							label={null}
							value={record[name.toLowerCase()]}
							onChanged={newVal => record[name.toLowerCase()] = newVal}
							required={true}
						/>
					);
				}
				return record[name.toLowerCase()] || "";
			}
		}));
	}

	public render(): React.ReactNode {
		const { mode, occupancyDataSet, getAllOccupancies, model, newOccupancy, setBusy } = this.props;

		return (
			<Collapse bordered={false} defaultActiveKey={['1']}>
				<Collapse.Panel header="Custom pax config" key="1">
					<DataTableView
						mode={mode}
						columns={this.columns.slice()}
						model={occupancyDataSet}
						rowKey={(m) => m.id}
						setBusy={setBusy}
						toolbarLeftItems={[
							{
								key: 'generate-all',
								disabled: mode === 'display' || !model,
								onClick: () => getAllOccupancies(model),
								name: 'All Ocuppancies'
							}
						]}
						hideToolbar={ToolbarVisibility.hideFooter | ToolbarVisibility.hidePagination | ToolbarVisibility.hideSearch}
						createNewItem={newOccupancy}
					/>
				</Collapse.Panel>
			</Collapse>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/contract/form/parts/contract-custom-occupancies.view.tsx